app.controller("SudoSignatureModalController", [
    "$scope", "$timeout", "$http", "$uibModalInstance", "AuthService", "params", "$uibModalInstance", "toastr",
    function ($scope, $timeout, $http, $uibModal, AuthService, params, $uibModalInstance, toastr) {
        $scope.user = params.user;

        $scope.uploadSignatureFile = function (files) {
            $timeout(function () {
                $scope.signatureFile = files[0];
                $scope.fileName = files[0].name;
            }, 0);
        };

        $scope.update = function () {
            if ($scope.signatureFile) {
                var fd = new FormData();
                $scope.disabled = true;
                fd.append('signatureFile', $scope.signatureFile);
                fd.append('userId', $scope.user._id);
                $http.post('/user/change-signature', fd, {
                    headers: {'Content-Type': undefined}
                }).then(function () {
                    toastr.success('ხელმოწერა შეცვლილია');
                    $uibModalInstance.close();
                })
            }
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
